import axios from 'axios';
import { encryptPayload, normalizeEncryptedApiResponse, plainObjectFromFormData } from './customerCrypto';
import { getCompanySettings, resolveCustomerApiEncrypt } from './companySettingsCache';

function pickAvatarFile() {
  if (typeof document === 'undefined') return null;
  const byId = document.getElementById('avatar');
  if (byId && byId.files && byId.files[0]) return byId.files[0];
  const byName = document.querySelector('input[type="file"][name="avatar"]');
  if (byName && byName.files && byName.files[0]) return byName.files[0];
  return null;
}

export async function postGetUsersList(fullUrl, jwtToken, { draw, start, length, searchValue, status }) {
  const settings = await getCompanySettings();
  const useEncrypt = resolveCustomerApiEncrypt(settings);
  const payload = {
    draw,
    start,
    length,
    search: { value: searchValue ?? '', regex: 'false' },
    searchValue: searchValue ?? '',
  };
  if (status !== undefined && status !== null && status !== '') {
    payload.status = status;
    payload.active = status;
  }
  let body;
  if (useEncrypt) {
    const ep = encryptPayload(payload);
    if (!ep) {
      return {};
    }
    const fd = new FormData();
    fd.append('encrypted_payload', ep);
    body = fd;
  } else {
    const fd = new FormData();
    fd.append('draw', String(draw));
    fd.append('start', String(start));
    fd.append('length', String(length));
    fd.append('search[value]', String(payload.search.value));
    fd.append('search[regex]', payload.search.regex);
    fd.append('searchValue', String(payload.searchValue));
    if (payload.status !== undefined) {
      fd.append('status', String(payload.status));
      fd.append('active', String(payload.active));
    }
    body = fd;
  }
  const response = await fetch(fullUrl, {
    method: 'POST',
    headers: { authorization: `Bearer ${jwtToken}` },
    body,
  });
  const raw = await response.json();
  return normalizeEncryptedApiResponse(raw, useEncrypt);
}

export async function postEditUser(fullUrl, jwtToken, userId) {
  const settings = await getCompanySettings();
  const useEncrypt = resolveCustomerApiEncrypt(settings);
  const fd = new FormData();
  fd.append('id', String(userId));
  if (useEncrypt) {
    const ep = encryptPayload({ id: String(userId) });
    if (ep) {
      fd.append('encrypted_payload', ep);
    }
  }
  const response = await fetch(fullUrl, {
    method: 'POST',
    headers: { authorization: `Bearer ${jwtToken}` },
    body: fd,
  });
  const raw = await response.json();
  return normalizeEncryptedApiResponse(raw, useEncrypt);
}

export async function axiosPostUsersMultipart(url, bearerToken, formData) {
  const settings = await getCompanySettings();
  const useEncrypt = resolveCustomerApiEncrypt(settings);
  let body;
  if (useEncrypt) {
    const plain = plainObjectFromFormData(formData);
    const ep = encryptPayload(plain);
    if (!ep) {
      throw new Error('ENCRYPT_KEY_MISSING');
    }
    body = new FormData();
    body.append('encrypted_payload', ep);
    const avatarFile = pickAvatarFile();
    if (avatarFile) {
      body.append('avatar', avatarFile);
    }
  } else {
    body = formData;
  }
  const res = await axios.post(url, body, {
    headers: { authorization: `Bearer ${bearerToken}` },
  });
  return normalizeEncryptedApiResponse(res.data, useEncrypt);
}
